module.exports = __webpack_public_path__ + "static/media/pic_representative.8cbc7ef5.jpg";